import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'

let r

/**
 * Provide the router to useRouter
 *
 * Router should never be imported directly except in "main.js"
 *
 * When access to the router is needed, "useRouter()" should
 * be called
 *
 * @example <caption>Providing the router</caption>
 * useRouter(router)
 *
 * @example <caption>Using the router</caption>
 * const router = useRouter()
 *
 * @param {Router} [router] - Router to provide
 * @returns {Router} Provided router
 */
function useRouter(router) {
  if (router) {
    r = router
  }
  if (!r) {
    dev.error(new Error('Router is being accessed before being defined'))
  }
  return r
}

export default useRouter
